// src/services/invoices.js
import { api } from "./api";

/** GET getbilldatesmd3.php?mainuser&paymentperiodsettings */
export async function fetchBillDateRanges(mainuser, paymentperiodsettings, { etag = null } = {}) {
  if (!mainuser) throw new Error("mainuser missing");

  const req = (useEtag) =>
    api.get("getbilldatesmd3.php", {
      params: { mainuser, paymentperiodsettings },
      headers: useEtag && etag ? { "If-None-Match": etag } : undefined,
      responseType: "text",
      transformResponse: (r) => r,
      validateStatus: (s) => (s >= 200 && s < 300) || s === 304,
    });

  try {
    const res = await req(true);
    return { status: res.status, text: res.data || "", etag: res.headers?.etag || "" };
  } catch {
    const res = await req(false); // fallback: no preflight
    return { status: res.status, text: res.data || "", etag: res.headers?.etag || "" };
  }
}

/** GET getsavedbillsmd.php?mainuser&date1&date2 */
export async function fetchSavedBills(mainuser, date1, date2, { etag = null } = {}) {
  if (!mainuser) throw new Error("mainuser missing");
  if (!date1 || !date2) throw new Error("date range missing");

  const req = (useEtag) =>
    api.get("getsavedbillsmd.php", {
      params: { mainuser, date1, date2 },
      headers: useEtag && etag ? { "If-None-Match": etag } : undefined,
      responseType: "text",
      transformResponse: (r) => r,
      validateStatus: (s) => (s >= 200 && s < 300) || s === 304,
    });

  try {
    const res = await req(true);
    return { status: res.status, text: res.data || "", etag: res.headers?.etag || "" };
  } catch {
    const res = await req(false);
    return { status: res.status, text: res.data || "", etag: res.headers?.etag || "" };
  }
}

/** POST delete_billmd.php (FormUrlEncoded like Android) */
export async function deleteBill(mainuser, period_start, period_end, kno) {
  const form = new URLSearchParams();
  form.set("mainuser", mainuser);
  form.set("period_start", period_start);
  form.set("period_end", period_end);
  form.set("kno", kno);

  const res = await api.post("delete_billmd.php", form, {
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    responseType: "text",
    transformResponse: (r) => r,
  });

  return res.data || "";
}

/** POST toggle_bill_status.php */
export async function toggleBillStatus(mainuser, kno, date1, date2, status) {
  const form = new URLSearchParams();
  form.set("mainuser", mainuser);
  form.set("kno", kno);
  form.set("date1", date1);
  form.set("date2", date2);
  form.set("status", status); // paid/unpaid

  const res = await api.post("toggle_bill_status.php", form, {
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    responseType: "text",
    transformResponse: (r) => r,
  });

  return res.data || "";
}

// ✅ NEW: fetchPendingBills (getpendingbillsmd2.php)
// ✅ NEW: fetchPendingBills (getpendingbillsmd2.php)
export async function fetchPendingBills(mainuser, date1, date2, { etag = null } = {}) {
  if (!mainuser) throw new Error("mainuser missing");
  if (!date1 || !date2) throw new Error("date range missing");

  const req = (useEtag) =>
    api.get("getpendingbillsmd2.php", {
      params: { mainuser, date1, date2 },
      headers: useEtag && etag ? { "If-None-Match": etag } : undefined,
      responseType: "text",
      transformResponse: (r) => r,
      validateStatus: (s) => (s >= 200 && s < 300) || s === 304,
    });

  try {
    const res = await req(true);
    return { status: res.status, text: res.data || "", etag: res.headers?.etag || "" };
  } catch {
    const res = await req(false); // fallback: no etag
    return { status: res.status, text: res.data || "", etag: res.headers?.etag || "" };
  }
}


// ✅ FIXED: fetchBillDetails uses axios "api" (server baseURL), not window.fetch (localhost)
export async function fetchBillDetails(
  mainuser,
  kno,
  date1,
  date2,
  { etag = null, source } = {}
) {
  if (!mainuser) throw new Error("mainuser missing");
  if (!kno) throw new Error("kno missing");
  if (!date1 || !date2) throw new Error("date range missing");

  const req = (useEtag) =>
    api.get("getbilldetailsmdd.php", {
      params: {
        mainuser,
        kno,
        date1,
        date2,
        ...(source ? { source } : {}), // pass "saved" for saved bills, omit for pending
      },
      headers: useEtag && etag ? { "If-None-Match": etag } : undefined,
      responseType: "text",
      transformResponse: (r) => r,
      validateStatus: (s) => (s >= 200 && s < 300) || s === 304,
    });

  try {
    const res = await req(true);
    return { status: res.status, text: res.data || "", etag: res.headers?.etag || "" };
  } catch {
    const res = await req(false);
    return { status: res.status, text: res.data || "", etag: res.headers?.etag || "" };
  }
}

/** POST savebillmd.php (FormUrlEncoded like Android) */
export async function saveBill(mainuser, payload_json) {
  const form = new URLSearchParams();
  form.set("mainuser", mainuser);
  form.set("payload_json", payload_json);

  const res = await api.post("savebillmd.php", form, {
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    responseType: "text",
    transformResponse: (r) => r,
  });

  return res.data || "";
}




